exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tags-input[data-v-52a0a9af]{display:flex;flex-wrap:wrap;align-items:center;border:1px solid #ccc;padding:5px}.tags-input input[data-v-52a0a9af]{border:none;flex:1;margin-right:5px}.tags-input ul[data-v-52a0a9af]{list-style:none;margin:0;padding:0;display:flex;flex-wrap:wrap}.tags-input li[data-v-52a0a9af]{background-color:#eee;border-radius:4px;padding:2px 6px;margin-right:5px;margin-bottom:5px;display:flex;align-items:center}.tags-input .remove-tag[data-v-52a0a9af]{margin-left:5px;cursor:pointer}", ""]);

// exports
